<div class="flags-layout">
  <a routerLink="/dashboard" class="back-link">
    <i class="bi bi-arrow-left"></i> Back to Dashboard
  </a>

  <h1 class="page-title">Flagged Questions</h1>
  <p class="page-subtitle">Questions you've flagged with red, yellow, or green, or questions with notes.</p>

  <!-- Filter panel -->
  <div class="panel filter-panel">
    <div class="filter-panel-header">
      <label class="panel-label mb-0">Filters</label>
      <button type="button" class="btn btn-sm btn-outline-secondary"
              (click)="reloadFlags()" [disabled]="isLoadingFlags || isSearching"
              title="Reload available flags">
        <i class="bi bi-arrow-clockwise"></i>
      </button>
    </div>
    <div class="filter-panel-body">
      <div *ngIf="isLoadingFlags" class="panel-loading">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Loading flags...
      </div>

      <div *ngIf="!isLoadingFlags && flags.length === 0" class="alert alert-info mb-0">
        No flags found yet. Flag some questions first (Study mode), or search for questions with notes.
      </div>

      <div *ngIf="flags.length > 0">
        <div class="filter-row mb-3">
          <label class="filter-label">Flags</label>
          <div class="flags-checkboxes">
            <div class="form-check" *ngFor="let flag of flags">
              <input class="form-check-input" type="checkbox" [id]="'flag_' + flag.id"
                     [(ngModel)]="flagSelection[flag.id]" [ngModelOptions]="{standalone: true}"
                     (ngModelChange)="onFilterChange()">
              <label class="form-check-label" [for]="'flag_' + flag.id">{{ flag.name }}</label>
            </div>
          </div>
        </div>

        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="withNotes"
                 [(ngModel)]="withNotes" [ngModelOptions]="{standalone: true}"
                 (ngModelChange)="onFilterChange()">
          <label class="form-check-label" for="withNotes">Questions with Notes</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Results panel -->
  <div class="panel results-panel" *ngIf="!isLoadingFlags">
    <div class="results-panel-header">
      <label class="panel-label mb-0">Results</label>
      <span class="results-badge">{{ results.length }}</span>
    </div>
    <div class="results-panel-body">
      <app-question-results-list
        [results]="results"
        [displayHtmlById]="resultDisplayHtmlById"
        [badgesById]="resultBadgesById"
        [showMatchedField]="false"
        [isLoading]="isSearching"
        [selectable]="true"
        (selectQuestion)="openDetail($event)"
        emptyMessage="No questions found for the selected filters."
      ></app-question-results-list>
    </div>
  </div>
</div>

<app-question-detail-modal
  [open]="detailOpen"
  [questionId]="detailQuestionId"
  [questionHtml]="detailQuestionHtml"
  [answersHtml]="detailAnswersHtml"
  [correctAnswer]="detailCorrectAnswer"
  (closed)="closeDetail()">
</app-question-detail-modal>
